var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#2AD200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3406 8.81365C15.7311 8.42312 16.3641 8.42312 16.7546 8.81365C17.1452 9.20417 17.1452 9.83718 16.7546 10.2277L11.2751 15.7072C11.0554 15.9268 10.7462 16.0318 10.4382 15.9914C10.13 15.9508 9.85735 15.7694 9.70191 15.5002L7.6814 12.0002L7.63452 11.9084C7.4271 11.4462 7.59939 10.8928 8.04761 10.634C8.49609 10.375 9.06172 10.503 9.35816 10.9142L9.41382 11.0002L10.782 13.3713L15.3406 8.81365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOk);
export default __webpack_public_path__ + "static/media/CheckOk.a95b00675270a9b7a6dbd5d87b330afc.svg";
export { ForwardRef as ReactComponent };